module.exports = __webpack_public_path__ + "img/35.f0cff68f.png";